var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 6.58993,
    fill: "#FCEFE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3258 15.838L20.6568 11.0598C19.9532 10.621 19.0618 10.621 18.3582 11.0598L10.6892 15.838C10.1111 16.2073 9.75586 16.8341 9.75586 17.5097V26.8504C9.75586 27.9441 10.6684 28.8285 11.7898 28.8285H27.2322C28.3537 28.8285 29.2662 27.9439 29.2662 26.8504L29.266 17.5097C29.259 16.8341 28.9039 16.2072 28.3258 15.838ZM17.0069 23.7299L12.2566 27.4216C12.1381 27.5121 11.992 27.5609 11.8527 27.5609C11.6577 27.5609 11.4626 27.4704 11.3303 27.3031C11.1073 27.0175 11.1561 26.5996 11.4487 26.3768L16.1991 22.6851C16.4847 22.4622 16.9027 22.511 17.1254 22.8036C17.3482 23.0961 17.2994 23.507 17.0069 23.7299ZM18.8806 22.1835L12.8625 17.9208C12.2008 17.4472 12.5421 16.4232 13.364 16.4232H25.6508C26.4727 16.4232 26.8141 17.4472 26.1524 17.9208L20.1343 22.1835C19.7583 22.4482 19.2567 22.4482 18.8806 22.1835ZM27.6776 27.31C27.5453 27.4772 27.3502 27.5678 27.1552 27.5678C27.0159 27.5678 26.8696 27.519 26.7513 27.4285L22.0009 23.7369C21.7153 23.5139 21.6597 23.096 21.8825 22.8106C22.1054 22.525 22.5234 22.4693 22.8088 22.6921L27.5592 26.3837C27.8518 26.6065 27.9006 27.0245 27.6776 27.31ZM22.6765 18.4641C22.6765 18.9028 22.3212 19.2581 21.8825 19.2581H17.6615C17.2228 19.2581 16.8675 18.9028 16.8675 18.4641C16.8675 18.0253 17.2227 17.67 17.6615 17.67H21.8825C22.3212 17.67 22.6765 18.0252 22.6765 18.4641Z",
    fill: "#EA925C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.18e894b00e43c2ab0c65eb72db17a3f7.svg";
export { ForwardRef as ReactComponent };